import { render } from "./TestMoney.vue?vue&type=template&id=c0a97dc8&scoped=true"
import script from "./TestMoney.vue?vue&type=script&lang=js"
export * from "./TestMoney.vue?vue&type=script&lang=js"

import "./TestMoney.vue?vue&type=style&index=0&id=c0a97dc8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a97dc8"]])

export default __exports__